export default "__VITE_ASSET__B_jVr__e__"